const initialState = {
    code: '',
    timerTime: 0,
    inputClass: 'Input-InputWrapper-d',
    errorTxt: '',
};
const courierVerification = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_COURIER_VERIFICATION_PAGE':
           return {...state, [action.name]: action.value};
        case 'CHANGE_TIMER_TIME_COURIER_VERIFICATION_PAGE':
            return {...state, timerTime: action.timer_time};
        default:
            return state;
    }
};

export default courierVerification;
